import { useState } from "react";
import axios from "axios";
import Modal from "./Modal";
import useJoinDonorCom from "../../hooks/post/useJoinDonorCom";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import FileUploader from "../../components/FileUploader";

const JoinDonorCommunity = () => {
  const uJoinDonorCom = useJoinDonorCom();
  const { duration } = uJoinDonorCom; 
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const access_token =localStorage.getItem("access_token")
  const [uploadedFilePath, setUploadedFilePath] = useState(null)
  const navigate = useNavigate();
 
  var empty_socials = {
    facebook: "",
    twitter: "",
    instagram: "",
    linkedin: "",
    tiktok: "",
  }

  const [socialLinks, setSocialLinks] = useState(empty_socials);

  const isValidUrl = (url) => {
    try {
      if (!url) return false;
      const parsedUrl = new URL(url);
      return ["http:", "https:"].includes(parsedUrl.protocol);
    } catch (_) {
      return false;
    }
  };

  const {t} = useTranslation("joinDonor")
  const translation = t("joinDonorModal")


  const submitFormData = async (formData) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_DOMAIN + "/user/create-membership/",
        formData,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setShowSuccessMessage(true);

        setTimeout(() => {
          uJoinDonorCom.close();
          setShowSuccessMessage(false);
          setErrorMessage("");
          setUploadedFilePath(null);
        }, 8000);
        setSocialLinks(empty_socials)

      }
    } catch (error) {
      if (error.response?.data?.error) {
        const errorData = error.response.data.error;
        const formattedErrors = Object.values(errorData).flat();
        setErrorMessage(formattedErrors.join(", "));
      } else if (error.response?.status === 400 && error.response?.data?.error?.non_field_error) {
        setErrorMessage(`${error.response?.data?.error?.non_field_error}`);
      } else if (error.response?.status === 429) {
        setErrorMessage(`${translation.submit_after_few_hour}`);
      } else {
        setErrorMessage(`${translation.something_wrong}`);
      }
    } finally {
      setIsLoading(false);
      setUploadedFilePath(null);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!access_token) {
      navigate("/auth/login");
      return;
    }

    // duration check
    if (duration === "3m") {
      // Keep only non-empty socials
      const socials = Object.fromEntries(
        Object.entries(socialLinks).filter(([_, value]) => value.trim() !== "")
      );

      // require at least one url
      if (Object.keys(socials).length === 0) {
        setErrorMessage("At least one social account is required");
        return;
      }

      // validate all entered urls
      for (const [platform, url] of Object.entries(socials)) {
        if (!isValidUrl(url)) {
          setErrorMessage(`Invalid URL for ${platform}`);
          return;
        }
      }

      const formData = new FormData();
      formData.append("document", JSON.stringify(socials));
      formData.append("plan", duration);

      await submitFormData(formData);
    } else {
      if (!uploadedFilePath) {
        setErrorMessage("Please upload your bank statement");
        return;
      }

      const formData = new FormData();
      formData.append("document", JSON.stringify(uploadedFilePath)); 
      formData.append("plan", duration);

      await submitFormData(formData);
    }
  };


  return (
    <>
      <Modal
        isOpen={uJoinDonorCom.isOpen}
        close={uJoinDonorCom.close}
        label={translation.heading}
        content={
          
          <div className="p-6">
            {showSuccessMessage && (
              <div className="bg-green-300 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-blue-800 mb-2">
                  {translation.success_heading}
                </h3>
                <p className="text-black dark:text-gray-800">
                  {translation.success_message}
                </p>
              </div>
            )}


            {duration === "3m" ? (
              <div className="space-y-3">
                <div>
                  <label className="block text-lg text-gray-800 mb-2 dark:text-white font-bold">
                    Facebook
                  </label>

                  <input
                    type="url"
                    placeholder="https://www.facebook.com/username/"
                    className="az-input-btn"
                    value={socialLinks.facebook}
                    onChange={(e) => setSocialLinks({ ...socialLinks, facebook: e.target.value })}
                  />
                </div>

                <div>
                  <label className="block text-lg text-gray-800 mb-2 dark:text-white font-bold">
                    Twitter                    
                  </label>
                  <input
                    type="url"
                    placeholder="https://x.com/username/"
                    className="az-input-btn"
                    value={socialLinks.twitter}
                    onChange={(e) => setSocialLinks({ ...socialLinks, twitter: e.target.value })}
                  />
                </div>

                <div>
                  <label className="block text-lg text-gray-800 mb-2 dark:text-white font-bold">
                    Instagram
                  </label>

                  <input
                    type="url"
                    placeholder="https://www.instagram.com/username/"
                    className="az-input-btn"
                    value={socialLinks.instagram}
                    onChange={(e) => setSocialLinks({ ...socialLinks, instagram: e.target.value })}
                  />
                </div> 

                <div>
                  <label className="block text-lg text-gray-800 mb-2 dark:text-white font-bold">
                    LinkedIn
                  </label>
                  <input
                  type="url"
                    placeholder="https://www.linkedin.com/in/username/"
                    className="az-input-btn"
                    value={socialLinks.linkedin}
                    onChange={(e) => setSocialLinks({ ...socialLinks, linkedin: e.target.value })}
                  />
                </div> 
                
                <div>
                  <label className="block text-lg text-gray-800 mb-2 dark:text-white font-bold">
                    TikTok
                  </label>
                  <input
                  type="url"
                    placeholder="https://www.tiktok.com/@username"
                    className="az-input-btn"
                    value={socialLinks.tiktok}
                    onChange={(e) => setSocialLinks({ ...socialLinks, tiktok: e.target.value })}
                  />
                </div>  
              
              </div>
            ) : (
              <div>
                <label className="block text-lg text-gray-800 mb-2 dark:text-white font-bold">
                  {translation.upload_bank_statement}
                </label>
                <FileUploader
                  returnFilePath={true}
                  allowedTypes={["pdf", "jpg", "jpeg", "png", "webp", "heic", "heif"]}
                  onSuccess={(filePath) => {
                    setUploadedFilePath(filePath);
                  }}
                  generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
                  maxSizeMB={100}
                  awsUploadDestination={"membership/username/docs"}
                  description={`${translation.bank_stat_description}`}
                />
              </div>
            )}

            <div className="flex gap-4 mt-10">
              <button
                type="button"
                onClick={handleSubmit}
                className={`w-full py-3 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all ${
                  isLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700 focus:ring-green-500"
                } ${
                  !uploadedFilePath 
                  ? "bg-gray-400"
                  : "bg-green-600 hover:bg-green-700 focus:ring-green-500"
                }`}
              >
                {isLoading ? `${translation.submitting}` : `${translation.submit}` }
              </button>
            </div>

            {errorMessage && (
              <p className="az-error-message">{errorMessage}</p>
            )}
  
          </div>
        }
      />
    </>
  );
};

export default JoinDonorCommunity;
